module.exports = __webpack_public_path__ + "03_long_gold.1dceda23.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/03_long_gold.png
// module id = RPhS
// module chunks = 0